import { useEffect } from 'react'
import { toastStore } from 'shared/ui'
import { WebsocketEvent } from 'entities/WebSocket/store/type'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventSettingsNumbersUnassignedRefreshFinished = (handle: () => void) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.SettingsNumbersUnassignedRefreshFinished, handle), [])
}

export const useGlobalEventSettingsNumbersUnassignedRefreshFinished = () => {
  const handle = () => {
    toastStore.add({
      type: 'success',
      title: 'Import finished',
      desc: 'Your data is ready.',
    })
  }
  useEventSettingsNumbersUnassignedRefreshFinished(handle)
}
